import { router } from 'expo-router';
import { useCallback } from 'react';

import { useAuthNavigationParams } from './use-auth-navigation-params';

export const useNavigateWithJwt = () => {
  const authNavigationParams = useAuthNavigationParams();
  const navigateWithJWT = useCallback(
    (route: string) => {
      router.replace({ pathname: route, params: authNavigationParams });
    },
    [authNavigationParams]
  );
  return { navigateWithJWT };
};
